import { render, staticRenderFns } from "./Delivery_Form.vue?vue&type=template&id=5f2e6634&scoped=true&"
import script from "./Delivery_Form.vue?vue&type=script&lang=js&"
export * from "./Delivery_Form.vue?vue&type=script&lang=js&"
import style0 from "./Delivery_Form.vue?vue&type=style&index=0&id=5f2e6634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2e6634",
  null
  
)

export default component.exports